module.exports = __webpack_public_path__ + "media/images/emblems/Tannay-coat_of_arms-1871ec401f7d7e642941fb959c92491b.svg";